import { Component, inject } from '@angular/core';
import { fundsSearchParamName, RouteSelectedFund } from '@components/fondsportrait/selected-fund';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'web-component-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
})
export class DemoComponent {
  protected readonly routeFund = inject(RouteSelectedFund);

  protected get jwt(): string {
    return new URLSearchParams(window.location.search).get('jwt');
  }
  protected set jwt(value: string) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('jwt', value);
    window.location.search = searchParams.toString();
  }

  protected async setRouteFunds(funds: string) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(fundsSearchParamName, funds);
    window.location.search = searchParams.toString();
  }
}
